export enum OTAUpdate {
  DISABLED,
  SILENT_ENABLED,
  ALERT_ENABLED,
}
